import React from 'react';
import { CheckBoxSelector } from 'hyperdb-utils';

const AmenitiesTab = ({ objectData, onChange, amenities, defaultLanguage }) => {
  const handleChangeAmenities = (field) => {
    const ids = field.value;
    const references = ids.map(id => {
      return { $type: 'reference', external: true, value: ['amenities', id] };
    });
    const deletedReferences = objectData.amenities
      .filter(amenity => ids.indexOf(amenity.value[1]) === -1)
      .map(amenity => ({ ...amenity, deleted: true }));
    onChange('amenities', { value: references.concat(deletedReferences) });
  };
  return (
    <fieldset>
      <CheckBoxSelector
        label="Amenities"
        name="amenities"
        value={ listReferences(objectData.amenities || []) }
        options={ amenitiesOptions(amenities, defaultLanguage) }
        onChange={ handleChangeAmenities }
        noScroll={true}
      />

    </fieldset>
  );
};

function listReferences(references) {
  return references.filter(a => !a.deleted).map(r => r.value[1]);
}
function amenitiesOptions(amenities, defaultLanguage) {
  if (!amenities) return [];
  return amenities.map(a => ({ name: (a.name.$i18n || {})[defaultLanguage], value: a.id }));
}

export default AmenitiesTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/AmenitiesTab.jsx